export default __webpack_public_path__ + "static/media/Combat Preperation.ac66fe62.png";